export class UtilizationRange {
  public low = 0; // TypeScript can infer number
  public high = 100; // TypeScript can infer number
  public pricePercentage = 100; // TypeScript can infer number
  public priceAmount?: number | null;
  public id = 0; // TypeScript can infer number
  public usePercent = true; // TypeScript can infer boolean
}
